<template>
	<div class="block-text" v-if="block.content" v-html="block.content.text"></div>
</template>

<script>

import scrollBehavior  from '@/mixins/scrollBehavior.js'
import loaderHandler  from '@/mixins/loaderHandler.js'

export default {
	mixins: [scrollBehavior, loaderHandler],
	props: ['block','currentLang', 'visible'],
}
</script>

<style lang="scss">
	.block-text{
		line-height:1.1;
		margin: auto;
		max-width:1200px;
		color: #141414;
		@media screen and (min-width:1024px){
			line-height:1.3;
		}
	}
	.block-text > *{
		font-size: 1.333333em;
		line-height: 2rem;
		@media screen and (max-width:768px){
			font-size: 1rem;
		}
	}
	.heading + .block-text{
		padding-top: 0;
	}

	.block-text p + p{
		margin-top: 1em;
	}

	.block-text a{
		color: inherit;
		border-bottom: 1px solid #141414;
		transition: all.3s ease;
	}

	.block-text a:hover{
		border-bottom: 1px solid var(--hover);
	}

	.heading + .block-text a{
		padding-top: 0;
	}

	.bloc--regular .block-text{
		max-width:850px;
	}

	@media screen and (min-width:1024px){
		.bloc--fullWidth .w_100 .block-text{
			padding: 5.33333em 0;
		}

		.bloc--fullWidth .w_33 .block-text{
			padding:3.33333em;
		}
		.bloc--fullWidth .w_66 .block-text,
		.bloc--fullWidth .w_50 .block-text{
			padding: 5.33333em;
		}

		.bloc--fullWidth .heading + .block-text{
			padding-top: 0;
		}
	}

	@media screen and (max-width:1024px){
		.bloc--fullWidth .block-text{
			padding: 2em;
		}
	}
</style>